"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(Froala) {
  Froala.PLUGINS.brandingColorsPlugin = function (editor) {
    var createElementFromHTML = function createElementFromHTML(htmlString) {
      var div = document.createElement('div');
      div.innerHTML = htmlString.trim();
      return div.firstElementChild;
    };

    var setBrandingColors = function setBrandingColors(colors) {
      editor.opts.brandingColors = colors;
    };

    var findPalette = function findPalette(popup) {
      return popup.find('.fr-color-set');
    };

    var findBrandingBreaker = function findBrandingBreaker(popup) {
      return findPalette(popup).find('.branding-breaker');
    };

    var createBrandingBreaker = function createBrandingBreaker(popup) {
      findPalette(popup).prepend('<br class="branding-breaker">');
    };

    var ensureBrandingBreaker = function ensureBrandingBreaker(popup) {
      findBrandingBreaker(popup).get(0) || createBrandingBreaker(popup);
    };

    var insertColor = function insertColor(popup, color) {
      var view = editor.$(editor.selection.element());
      var rgbColor = view.css('color');
      var hexColor = editor.helpers.RGBToHex(rgbColor);
      var isCurrentColor = hexColor.toUpperCase() === color.toUpperCase();
      var colorButton = createElementFromHTML("\n        <span\n          class=\"fr-command fr-select-color ".concat(isCurrentColor ? 'fr-active-item' : '', " branding-color\"\n          style=\"background:").concat(color, ";\"\n          tabindex=\"-1\"\n          aria-selected=\"false\"\n          role=\"button\"\n          data-cmd=\"applytextColor\"\n          data-param1=\"").concat(color, "\">\n          <span class=\"fr-sr-only\">\n            Color").concat(color, "\n          </span>\n        <span>\n      "));

      if (isCurrentColor) {
        colorButton.appendChild(createElementFromHTML('<span class="fr-selected-color" aria-hidden="true"></span>'));
      }

      findPalette(popup).get(0).insertBefore(colorButton, findBrandingBreaker(popup).get(0));
    };

    var configureBrandingPalette = function configureBrandingPalette(colors) {
      var popup = editor.popups.get('textColor.picker');
      ensureBrandingBreaker(popup);
      findPalette(popup).find('.branding-color').remove();
      editor.selection.restore();
      colors.forEach(function (color) {
        return insertColor(popup, color);
      });
      editor.selection.save();
    };

    var _init = function _init() {
      editor.events.on('popups.show.textColor.picker', function () {
        var colors = editor.opts.brandingColors.slice(0, editor.opts.colorsStep);

        if (colors.length > 0) {
          configureBrandingPalette(colors);
        }
      });
    };

    return {
      _init: _init,
      setBrandingColors: setBrandingColors
    };
  };
};

exports.default = _default;